module.exports = __webpack_public_path__ + "img/thumb_document_txt.9d3f472f.svg";